import React, { useState, useEffect } from 'react';
import { Popover, Button, Card, Select, Statistic } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import useProfilePageHook from '../ProfilePage/ProfilePageHook';
import Notification from '../Notification/NotificationMessage';

const { Option } = Select;


const NewTaskPopover = ({ onInitiateTask, maxURLCount, isProcessing }) => {
  const navigate = useNavigate();
  const { generationCredit, fetchUserProfile } = useProfilePageHook();
  const [urlCount, setUrlCount] = useState(10);
  const [isInitiating, setIsInitiating] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleInitiate = async () => {
    if (generationCredit >= urlCount) {
      setIsInitiating(true);
      await onInitiateTask(urlCount);
      setIsInitiating(false);
      setPopoverVisible(false); // Close the popover on successful initiation
    } else {
      Notification.error('Not enough generation credits');
    }
  };

  const handleChange = value => {
    setUrlCount(value);
    console.log(value)
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  return (
    <Popover
      content={
        <Card title="Initiate Task" bordered={false} style={{ width: 300 }}>
          <p style={{ marginTop: 0, marginBottom: 15 }}>
            DealightAI follows instructions in your sales agent setting. To change how DealightAI conducts real-time research, go to the 
            <Button type="link" onClick={() => navigate('/leads/campaign_setup')} style={{ padding: 0, marginLeft: '2px', height: 'auto' }}>setup page</Button>.
          </p>
          <Statistic title="Credits Left:" value={generationCredit} />
          <p>Select urls to analyze:</p>
          <Select defaultValue={10} style={{ width: '100%', marginBottom: 15 }} onChange={handleChange}>
            {[...Array(maxURLCount).keys()].map(i => (
              <Option key={i + 1} value={(i + 1) * 10}>
                {(i + 1) * 10} URL{(i + 1) * 10 > 10 ? 's' : ''}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            onClick={handleInitiate}
            style={{ width: '100%', marginTop: '0px' }}
            disabled={isInitiating || generationCredit < urlCount}
          >
            Run and analyze selected URLs ({urlCount})
          </Button>
        </Card>
      }
      trigger="click"
      visible={popoverVisible}
      onVisibleChange={setPopoverVisible}
    >
      <Button type="primary" icon={<PlayCircleOutlined />} disabled={isProcessing}>
        Initiate
      </Button>
    </Popover>
  );
};

export default NewTaskPopover;
